import { Injectable, inject } from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { Plugin } from '@jeppesen-foreflight/jmkw-types';
import { FLIGHT_RULES_LEGEND } from './flight-rules.legend';
import { FlightRulesIfrPluginService } from './flight-rules-ifr/flight-rules-ifr.plugin.service';
import { FlightRulesLifrPluginService } from './flight-rules-lifr/flight-rules-lifr.plugin.service';
import { FlightRulesMvfrPluginService } from './flight-rules-mvfr/flight-rules-mvfr.plugin.service';

@Injectable({
  providedIn: 'root'
})
export class FlightRulesPluginService {
  private _flightRulesIfrPlugin$ = inject(FlightRulesIfrPluginService);
  private _flightRulesLifrPlugin$ = inject(FlightRulesLifrPluginService);
  private _flightRulesMvfrPlugin$ = inject(FlightRulesMvfrPluginService);

  plugin$ = combineLatest([
    this._flightRulesIfrPlugin$.plugin$,
    this._flightRulesLifrPlugin$.plugin$,
    this._flightRulesMvfrPlugin$.plugin$
  ]).pipe(
    map(
      (children) =>
        new Plugin({
          id: 'flight-conditions',
          legend: FLIGHT_RULES_LEGEND,
          children
        })
    )
  );
}
